import { isValid as isValidDate } from "date-fns";
const DATE_INPUT_PATTERN = /\d\d?\/\d\d?\/\d\d\d\d/;

export const isValid = (dateString: string) => {
  return dateString.match(DATE_INPUT_PATTERN) && isValidDate(new Date(dateString));
};
